// "use client";
// import { IconColumns } from "@tabler/icons-react";
// import { useEffect, useRef, useState } from "react";

// type ColumnsData = {
//   id?: number;
//   text?: string;
//   isShow?: boolean;
//   value?: string;
// };

// type Props = {
//   columnsData: ColumnsData[];
//   setHeadings?: (value: string | undefined, checked: boolean) => void;
// };

// export default function ColumnsFilter({ columnsData, setHeadings }: Props) {
//   const [open, setOpen] = useState(false);
//   const dropdownRef = useRef<HTMLDivElement>(null);

//   useEffect(() => {
//     const handleClickOutside = (event: MouseEvent) => {
//       if (
//         dropdownRef.current &&
//         !dropdownRef.current.contains(event.target as Node)
//       ) {
//         setOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className="relative inline-block" ref={dropdownRef}>
//       <div
//         onClick={() => setOpen((prev) => !prev)}
//         className="border-[0.5px] border-gray-300 bg-white rounded-full p-2 cursor-pointer text-sm text-[#212121]"
//       >
//         <IconColumns strokeWidth={1.5} size={22} />
//       </div>
//       {open && (
//         <div className="absolute mt-2 right-0 bg-white border border-gray-200 shadow-md rounded-md w-52 z-10  max-h-[200px] scrollbar-clean overflow-hidden overflow-y-auto">
//           {columnsData.map((h, i) => (
//             <label
//               className="space-x-2 flex items-center cursor-pointer border-b border-[#d2d2d2] px-3 py-2.5 hover:bg-[#FBD037]/10 last:border-none"
//               key={i}
//             >
//               <label className="flex items-center cursor-pointer relative">
//                 <input
//                   type="checkbox"
//                   checked={!!h.isShow}
//                   className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-[#FBD037] checked:border-[#FBD037]"
//                   onChange={(e) => {
//                     setHeadings && setHeadings(h.value, e.target.checked);
//                   }}
//                 />
//                 <span className="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     className="h-3.5 w-3.5"
//                     viewBox="0 0 20 20"
//                     fill="currentColor"
//                     stroke="currentColor"
//                     strokeWidth={1}
//                   >
//                     <path
//                       fillRule="evenodd"
//                       d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
//                       clipRule="evenodd"
//                     />
//                   </svg>
//                 </span>
//               </label>
//               <span className="text-sm">{h.text}</span>
//             </label>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

"use client";
import { IconColumns } from "@tabler/icons-react";
import { useEffect, useRef, useState } from "react";

type ColumnsData = {
  id?: number;
  text?: string;
  isShow?: boolean;
  value?: string;
};

type Props = {
  columnsData: ColumnsData[];
  setHeadings?: (value: string | undefined, checked: boolean) => void;
  triggerClassName?: string;
};

export default function ColumnsFilter({ columnsData, setHeadings, triggerClassName }: Props) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const allSelected = columnsData.every((col) => col.isShow);
  const someSelected = columnsData.some((col) => col.isShow);

  const handleSelectAll = (checked: boolean) => {
    columnsData.forEach((col) => {
      setHeadings?.(col.value, checked);
    });
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className={
          triggerClassName ||
          "h-9 w-9 border border-slate-200 bg-white rounded-lg hover:bg-slate-50 flex items-center justify-center text-[#212121] shadow-sm hover:shadow-md hover:-translate-y-0.5 active:translate-y-0 active:scale-95 transition-all duration-150 cursor-pointer select-none"
        }
      >
        <IconColumns strokeWidth={1.5} size={18} />
      </button>

      {open && (
        <div className="absolute mt-2 right-0 bg-white border border-gray-200 shadow-lg rounded-md w-56 z-40 max-h-64 overflow-y-auto scrollbar-clean">
          {/* Select All */}
          <label className="flex items-center px-3 py-2.5 border-b border-gray-200 hover:bg-[#FBD037]/10 cursor-pointer">
            <div className="flex items-center relative">
              <input
                type="checkbox"
                checked={allSelected}
                ref={(input) => {
                  if (input) input.indeterminate = someSelected && !allSelected;
                }}
                className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-[#FBD037] checked:border-[#FBD037]"
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
              <span className="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-3.5 w-3.5"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
              <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-0.5 bg-white opacity-0 peer-indeterminate:opacity-100 pointer-events-none" />
            </div>
            <span className="ml-3 text-sm font-medium text-gray-700">
              Select All
            </span>
          </label>

          {columnsData.map((col, i) => (
            <label
              key={i}
              className="flex items-center px-3 py-2.5 border-b border-[#d2d2d2] hover:bg-[#FBD037]/10 cursor-pointer last:border-none"
            >
              <div className="flex items-center relative">
                <input
                  type="checkbox"
                  checked={!!col.isShow}
                  className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-[#FBD037] checked:border-[#FBD037]"
                  onChange={(e) => {
                    setHeadings?.(col.value, e.target.checked);
                  }}
                />
                <span className="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-3.5 w-3.5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                </span>
              </div>
              <span className="ml-3 text-sm text-gray-700">{col.text}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
}
